import statuses from '@/store/statuses';
import Services from '@/services/index';
import VuexTypes from '@/store/types/index';

const RoleService = Services.roles;
const RoleTypes = VuexTypes.roles;
export default {
  [RoleTypes.ROLES_LIST]: ({ commit, state }, page = 1) => {
    state.rolesList['status'] = statuses.LOADING;
    RoleService.list(page).then((data) => {
      commit(RoleTypes.ROLES_LIST, data);
    }).catch((errResponse) => {
      commit(RoleTypes.ROLES_LIST, errResponse);
    });
  },
  [RoleTypes.ROLE_CREATE_DATA]: ({ commit, state }) => {
    state.roleCreateData['status'] = statuses.LOADING;
    RoleService.createData().then((data) => {
      commit(RoleTypes.ROLE_CREATE_DATA, data);
    }).catch((errResponse) => {
      commit(RoleTypes.ROLE_CREATE_DATA, errResponse);
    });
  },
  [RoleTypes.ROLE_UPDATE_DATA]: ({ commit, state }, roleId) => {
    state.roleUpdateData['status'] = statuses.LOADING;
    RoleService.editData(roleId).then((data) => {
      commit(RoleTypes.ROLE_UPDATE_DATA, data);
    }).catch((errResponse) => {
      commit(RoleTypes.ROLE_UPDATE_DATA, errResponse);
    });
  },
  [RoleTypes.ROLE_CREATE]: ({ commit, state }, createData) => {
    state.roleCreate['status'] = statuses.LOADING;
    RoleService.create(createData).then((data) => {
      commit(RoleTypes.ROLE_CREATE, data);
    }).catch((errResponse) => {
      commit(RoleTypes.ROLE_CREATE, errResponse);
    });
  },
  [RoleTypes.ROLE_UPDATE]: ({ commit, state }, { id, update }) => {
    state.roleUpdate['status'] = statuses.LOADING;
    RoleService.update(id, update).then((data) => {
      commit(RoleTypes.ROLE_UPDATE, data);
    }).catch((errResponse) => {
      commit(RoleTypes.ROLE_UPDATE, errResponse);
    });
  },
};
